import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 获取store文件下所有js文件
const context = require.context('@/store', true, /\.js$/)
// 所有mudule组成的对象
const moduleStores = {}
// 所有需要热更新的module文件名组成的数组
const hotNameArray = []
context.keys().forEach(key => {
  // context.keys()    返回匹配成功模块的名字组成的数组
  const fileName = key.slice(2, -9)
  const hotName = key.slice(0, -9)

  const fileModule = context(key).default
  if (fileModule && fileModule.state) {
    moduleStores[fileName] = {
      ...fileModule,
      namespaced: true
    }
  }
  if (hotName && hotName.length > 2) {
    hotNameArray.push(hotName)
  }
})

const store = new Vuex.Store({
  modules: moduleStores
})

if (module.hot) {
  // 使 action 和 mutation 成为可热重载模块
  module.hot.accept(hotNameArray, () => {
    // 加载新模块
    store.hotUpdate({
      modules: moduleStores
    })
  })
}
export default store



// WEBPACK FOOTER //
// ./src/store/index.js